import Training from '../../training';

/**
 * Create the action
 */

const { thunk, request, success, error } = Training.show(({ trainingId }, fetch) => {
    return fetch.get(`/trainings/${trainingId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
